import { API_BASE_URL } from './types';
import { Counter } from '../../types';
import axios from 'axios';

/**
 * Fetch all counters
 */
export async function fetchCounters(): Promise<any[]> {
  const response = await fetch(`${API_BASE_URL}/api/counters?includePrivate=true`);
  if (!response.ok) throw new Error('Failed to fetch counters');
  const data = await response.json();
  return data.sort((a: any, b: any) => 
    new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  );
}

/**
 * Create a new counter
 */
export async function createCounter(counterData: { 
  name: string, 
  isPrivate?: boolean,
  email?: string,
  ownerEmail?: string,
  isPublic?: boolean
}): Promise<Counter> {
  const response = await fetch(`${API_BASE_URL}/api/counters`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(counterData)
  });
  
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.message || 'Failed to create counter');
  }
  
  return await response.json();
}

/**
 * Update a counter
 */
export async function updateCounter(
  counterId: string,
  counterData: { 
    name: string, 
    isPrivate?: boolean,
    timeLimitType?: 'deadline' | 'countdown' | null,
    deadline?: string | null,
    timezone?: string | null,
    countdownMinutes?: number | null,
    countdownStartedAt?: string | null
  },
  isOwnerUrl = false
): Promise<any> {
  const url = `${API_BASE_URL}/api/counters/${counterId}${isOwnerUrl ? '?isOwnerUrl=true' : ''}`;
  
  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(counterData)
  });
  
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.message || 'Failed to update counter');
  }
  
  return await response.json();
}

/**
 * Delete a counter
 */
export async function deleteCounter(counterId: string, isOwnerUrl = false): Promise<{ message: string }> {
  const url = `${API_BASE_URL}/api/counters/${counterId}${isOwnerUrl ? '?isOwnerUrl=true' : ''}`;
  
  const response = await fetch(url, {
    method: 'DELETE'
  });
  
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Failed to delete counter');
  }
  
  return await response.json();
} 